import React from 'react'
import { Button } from '@deal/components'
import styles from './styles.css'
import { InterstitialProps } from '#src/components/Path/Interstitials'
import { usePathContext } from '../../PathContext'

const WhatHappensNext: React.SFC<InterstitialProps> = ({ categorySlug }) => {
  const pathContext = usePathContext()

  switch (categorySlug) {
    case 'golf':
      return (
        <section className={styles.page}>
          <div className={styles.headline}>What happens next</div>

          <div className={styles.body}>
            We'll connect you with a real golf expert with tons of knowledge about golfing. You can
            call, text, email or chat with them on our site!
          </div>
          <div className={styles.lowerHeadline}>What your expert can do:</div>
          <ol className={styles.list}>
            <li>Pick out golf gear to help improve your game</li>
            <li>Help you compare different options</li>
            <li>Analyze your golf swing and give you feedback</li>
          </ol>
          <div className={styles.body}>
            Once you’ve found the right products, you can buy them on our site.
          </div>
          <div className={styles.footer}>
            <div className={styles.dark}>Questions or concerns?</div>
            Ask your expert! They're here to help.
          </div>

          <div className={styles.actions}>
            {!pathContext.isBackButtonHidden && (
              <div>
                <Button
                  className={styles.back}
                  type="button"
                  size="large"
                  variant="contrast-light"
                  tabIndex={2}
                  onClick={pathContext.onPageBack}
                  disabled={pathContext.isSubmitting}
                >
                  Back
                </Button>
              </div>
            )}
            <Button
              type="submit"
              size="large"
              tabIndex={1}
              disabled={pathContext.isSubmitting}
              onClick={pathContext.onPageSubmitted}
            >
              {pathContext.isSubmitting ? 'Submitting...' : "Let's do this!"}
            </Button>
          </div>
        </section>
      )

    default:
      return (
        <section className={styles.page}>
          <div className={styles.headline}>What happens next</div>

          <div className={styles.body}>
            We'll connect you with a real expert with tons of knowledge about your gear. You can
            call, text, email or chat with them on our site!
          </div>
          <div className={styles.lowerHeadline}>What your expert can do:</div>
          <ol className={styles.list}>
            <li>Make recommendations and find some gear customized for you</li>
            <li>Help you compare different options in your price range</li>
            <li>Chat with you on the go over text, phone or web</li>
          </ol>
          <div className={styles.body}>Once you're happy, you can buy your stuff on our site.</div>
          <div className={styles.footer}>
            <div className={styles.dark}>Questions or concerns?</div>
            Ask your expert! They're here to help.
          </div>

          <div className={styles.actions}>
            {!pathContext.isBackButtonHidden && (
              <div>
                <Button
                  className={styles.back}
                  type="button"
                  size="large"
                  variant="contrast-light"
                  tabIndex={2}
                  onClick={pathContext.onPageBack}
                  disabled={pathContext.isSubmitting}
                >
                  Back
                </Button>
              </div>
            )}
            <Button
              type="submit"
              size="large"
              tabIndex={1}
              disabled={pathContext.isSubmitting}
              onClick={pathContext.onPageSubmitted}
            >
              {pathContext.isSubmitting ? 'Submitting...' : "Let's do this!"}
            </Button>
          </div>
        </section>
      )
  }
}

export default WhatHappensNext
